<template>
  <button
    type="button"
    class="org-option-tile"
    :class="{
      'org-option-tile--active': modelValue,
      'org-option-tile--disabled': disabled,
      'org-option-tile--compact': compact,
    }"
    :disabled="disabled"
    @click="toggle"
  >
    <span class="org-option-tile__glow" aria-hidden="true" />
    <span
      class="org-option-tile__icon"
      :class="{ 'org-option-tile__icon--active': modelValue }"
    >
      <v-icon size="18">{{ icon }}</v-icon>
    </span>
    <span class="org-option-tile__text">
      <span class="org-option-tile__label">{{ label }}</span>
      <span v-if="hint" class="org-option-tile__hint">{{ hint }}</span>
    </span>
    <span class="org-option-tile__mark" aria-hidden="true">
      <v-icon v-if="modelValue" size="14">mdi-check</v-icon>
    </span>
  </button>
</template>

<script>
export default {
  name: 'OrgOptionTile',
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, required: true },
    hint: { type: String, default: '' },
    icon: { type: String, default: 'mdi-check-circle-outline' },
    compact: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      if (this.disabled) return
      this.$emit('update:modelValue', !this.modelValue)
    },
  },
}
</script>
